import { useTranslation } from 'react-i18next'

import { getMassActionRequestsForConnect } from '../../../../api'
import { useUkTimeZone } from '../../../../hooks'
import { getMassActionExcludeIdParam } from '../../../../utils/common'
import { stopPropagation } from '../../../../utils/events'
import {
  AttachServiceRequestsModal,
  getAttachServiceRequestsEditStatusInitialNotifications,
} from '../../AttachServiceRequestsModal'
import {
  REQUEST_ACTION_ARCHIVE_MASS,
  REQUEST_ACTION_ASSIGN_MASS,
  REQUEST_ACTION_CONNECT_DOC_FLOW_MASS,
  REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS,
  REQUEST_ACTION_CREATE_DOC_FLOW_MASS,
  REQUEST_ACTION_DUE_DATE_MASS,
  REQUEST_ACTION_EDIT_CATEGORY_MASS,
  REQUEST_ACTION_EDIT_LABEL_MASS,
  REQUEST_ACTION_EDIT_PROVIDER_MASS,
  REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS,
  REQUEST_ACTION_MARK_AS_PRIVATE_MASS,
  REQUEST_ACTION_MARK_AS_PUBLIC_MASS,
  REQUEST_ACTION_MARK_AS_READ_MASS,
  REQUEST_ACTION_MARK_AS_UNREAD_MASS,
  REQUEST_ACTION_RESTORE_MASS,
  REQUEST_ACTION_UPDATE_STATUS_MASS,
  REQUEST_MASS_ACTION_ID_KEY,
} from '../../Request.constants.actions'
import {
  getRequestEditStatusActionTypes,
  getRequestItemActionTypes,
  getRequestMassActionTypes,
  isRequestSelectionWithArchived,
} from '../../Request.utils.actions'
import {
  getRequestEditCategoryModalInitialValues,
  RequestEditCategoryModal,
} from '../../RequestEditCategoryModal'
import {
  getRequestEditDueDateWithActionTypesInitialValues,
  getRequestEditDueDateWithActionTypesValidationSchema,
  RequestEditDueDateModal,
  RequestEditDueDateModalFieldsWithActionTypes,
} from '../../RequestEditDueDateModal'
import {
  getRequestEditLabelModalInitialValues,
  RequestEditLabelModal,
} from '../../RequestEditLabelModal'
import {
  getRequestEditManagerModalInitialValues,
  getRequestEditManagerModalPayload,
  RequestEditManagerModal,
} from '../../RequestEditManagerModal'
import {
  getRequestEditProviderModalInitialValues,
  getRequestEditProviderModalPayload,
  RequestEditProviderModal,
} from '../../RequestEditProviderModal'
import {
  getRequestEditStatusModalInitialValues,
  getRequestEditStatusModalWithActionTypesInitialValues,
  RequestEditStatusModal,
  RequestEditStatusModalFieldsWithActionTypes,
} from '../../RequestEditStatusModal'

export function useRequestTableMassActions({
  excludeIds,
  filterValues,
  getHandleSubmitActionWithType,
  handleAttachRequests,
  handleConnectDocFlowsToSelected,
  handleCreateDocFlowForSelected,
  massAction,
  selectAllPages,
  selected,
  selectedIds,
  showConfirmModal,
  sub,
  onCloseModal,
  onSetModal,
}) {
  const { t } = useTranslation()

  const { timezone } = useUkTimeZone()

  function groupRestoredRequests(action) {
    return ({ payload }) =>
      massAction({
        action,
        value: { restore_archived_with_status: payload?.status },
      })
  }

  function restoreArchived() {
    onSetModal(
      <RequestEditStatusModal
        initialNotifications={getAttachServiceRequestsEditStatusInitialNotifications()}
        initialValues={getRequestEditStatusModalInitialValues()}
        needToCheckNoChanges={false}
        onClose={onCloseModal}
        onSubmit={groupRestoredRequests(
          REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS
        )}
      />
    )
  }

  function setMassAction(action) {
    function handleSubmitMassConfirmAction(e) {
      stopPropagation(e)
      massAction({ action })
    }

    switch (action) {
      case REQUEST_ACTION_ARCHIVE_MASS:
        showConfirmModal({
          description: t('Modal.RequestMassArchiveConfirmationTextKey'),
          submitText: t('Modal.RequestMassArchiveBtnKey'),
          onSubmit: handleSubmitMassConfirmAction,
        })
        break
      case REQUEST_ACTION_ASSIGN_MASS:
        onSetModal(
          <RequestEditManagerModal
            formFieldsProps={{
              actionTypes: getRequestMassActionTypes(),
            }}
            getPayload={getRequestEditManagerModalPayload}
            initialValues={getRequestEditManagerModalInitialValues()}
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break
      case REQUEST_ACTION_DUE_DATE_MASS:
        onSetModal(
          <RequestEditDueDateModal
            Fields={RequestEditDueDateModalFieldsWithActionTypes}
            action={action}
            formFieldsProps={{
              actionTypes: getRequestItemActionTypes(),
            }}
            initialValues={getRequestEditDueDateWithActionTypesInitialValues(
              null,
              timezone
            )}
            validationSchema={
              getRequestEditDueDateWithActionTypesValidationSchema
            }
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break
      case REQUEST_ACTION_EDIT_LABEL_MASS:
        onSetModal(
          <RequestEditLabelModal
            formFieldsProps={{
              actionTypes: getRequestMassActionTypes(),
            }}
            initialValues={getRequestEditLabelModalInitialValues()}
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break
      case REQUEST_ACTION_EDIT_CATEGORY_MASS:
        onSetModal(
          <RequestEditCategoryModal
            formFieldsProps={{
              actionTypes: getRequestItemActionTypes(),
            }}
            initialValues={getRequestEditCategoryModalInitialValues()}
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break
      case REQUEST_ACTION_EDIT_PROVIDER_MASS:
        onSetModal(
          <RequestEditProviderModal
            formFieldsProps={{
              actionTypes: getRequestMassActionTypes(),
            }}
            getPayload={getRequestEditProviderModalPayload}
            initialValues={getRequestEditProviderModalInitialValues()}
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break
      case REQUEST_ACTION_RESTORE_MASS:
        showConfirmModal({
          description: t('Modal.RequestMassRestoreConfirmationTextKey'),
          submitText: t('Modal.RequestMassRestoreBtnKey'),
          onSubmit: handleSubmitMassConfirmAction,
        })
        break
      case REQUEST_ACTION_MARK_AS_READ_MASS:
        massAction({ action })
        break
      case REQUEST_ACTION_MARK_AS_UNREAD_MASS:
        massAction({ action })
        break
      case REQUEST_ACTION_MARK_AS_PUBLIC_MASS:
        showConfirmModal({
          description: t('Modal.RequestMarkAsPublicMassConfirmationTextKey'),
          submitText: t('Modal.RequestMarkAsPublicMassBtnKey'),
          onSubmit: handleSubmitMassConfirmAction,
        })
        break
      case REQUEST_ACTION_MARK_AS_PRIVATE_MASS:
        showConfirmModal({
          description: t('Modal.RequestMarkAsPrivateMassConfirmationTextKey'),
          submitText: t('Modal.RequestMarkAsPrivateMassBtnKey'),
          onSubmit: handleSubmitMassConfirmAction,
        })
        break
      case REQUEST_ACTION_UPDATE_STATUS_MASS:
        onSetModal(
          <RequestEditStatusModal
            Fields={RequestEditStatusModalFieldsWithActionTypes}
            action={action}
            formFieldsProps={{
              actionTypes: getRequestEditStatusActionTypes(),
              typeSelectProps: {
                disabled: true,
              },
            }}
            initialValues={getRequestEditStatusModalWithActionTypesInitialValues()}
            needToCheckNoChanges={false}
            onClose={onCloseModal}
            onSubmit={getHandleSubmitActionWithType({ action })}
          />
        )
        break

      case REQUEST_ACTION_CONNECT_DOC_FLOW_MASS:
        handleConnectDocFlowsToSelected()
        break
      case REQUEST_ACTION_CREATE_DOC_FLOW_MASS:
        handleCreateDocFlowForSelected()
        break

      case REQUEST_ACTION_CONNECT_SERVICE_REQUEST_MASS: {
        const excludeId = getMassActionExcludeIdParam({
          excludeIds,
          selectAllPages,
        })

        async function attach(values) {
          return handleAttachRequests({ ...values, action })
        }

        onSetModal(
          <AttachServiceRequestsModal
            multipleSelection
            showLimitNotification
            apiParams={{
              exclude_filters: {
                ...filterValues,
                [REQUEST_MASS_ACTION_ID_KEY]: selectedIds,
                exclude_id: excludeId,
              },
            }}
            loadItems={getMassActionRequestsForConnect}
            onAttach={attach}
            onClose={onCloseModal}
          />
        )
        break
      }

      case REQUEST_ACTION_GROUP_SERVICE_REQUESTS_MASS: {
        function archiveConfirmHandler(e) {
          stopPropagation(e)

          showConfirmModal({
            cancelText: t('Modal.RequestRestoreCancelTextKey'),
            description: t('Modal.RequestRestoreConfirmationTextKey'),
            submitText: t('Modal.RequestRestoreBtnKey'),
            onCancel: handleSubmitMassConfirmAction,
            onSubmit: restoreArchived,
          })
        }

        const confirmHandler = isRequestSelectionWithArchived({
          selectAllPages,
          selected,
          sub,
        })
          ? archiveConfirmHandler
          : handleSubmitMassConfirmAction

        showConfirmModal({
          description: t('Modal.RequestGroupConfirmationTextKey'),
          submitText: t('Modal.RequestGroupBtnKey'),
          onSubmit: confirmHandler,
        })
        break
      }
      default:
        return null
    }
  }

  return { setMassAction }
}
